import React, {useState, useEffect,useContext} from 'react';
import { RootStoreContext } from '../stores/RootStore';
import { useLocation } from "react-router-dom";

export const StudentResponse = () => {

    const rootStore = useContext(RootStoreContext);
    const { studentresponse} = rootStore.commonStore; 
    const [btn, setBtn] = useState(false);
    const search = useLocation().search;
    const code=new URLSearchParams(search).get("code");

    function res() 
    {
        studentresponse(String(code), 1).then(function(response) {
            if(response.status=="200")
                setBtn(true)
        })
        
    }

    return (
        <React.Fragment>
            <div className="confirmation" >
                <div className="content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12" >
                                <div className="card card-primary card-outline">
                                    <div className="card-header">
                                        <h5 className="card-title m-0">Study Evaluation Confirmation</h5>
                                    </div>
                                    <div className="card-body">
                                        <p>
                                            <h6 className="card-title">Please click below button to confirm that you have received and read the email related to the study evaluation results.</h6>
                                        </p>
                                        <p><br/></p>
                                        <button disabled={btn} onClick={() => res()} className="btn btn-primary" type="button">Confirm</button>
                                        <p className="card-text"><br/>Thank you</p>
                                    </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default StudentResponse;